export const reasonTranslator = {
    "conditions": "Stengt pga. dårlige snø-/værforhold.",
    "technical": "Stengt pga. tekniske problemer.",
    "closed": "Stengt"
} 
